var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowMenu
    ? _c(
        "div",
        {
          staticClass: "nav-bar",
          style: {
            width: !_vm.isCollapse ? "156px !important" : "64px !important",
          },
        },
        [
          _vm.isShow
            ? _c(
                "div",
                {
                  staticClass: "child-bar",
                  class: !_vm.isCollapse ? "plr12" : "",
                },
                [
                  _vm.menuList[
                    _vm.sidebarParentCur.length > 13
                      ? _vm.sidebarParentCur.slice(13)
                      : _vm.sidebarParentCur
                  ]
                    ? _c(
                        "div",
                        {
                          staticClass: "over-text1",
                          class: !_vm.isCollapse
                            ? "title-box-open"
                            : "title-box-close",
                        },
                        [
                          _vm._v(
                            "\n      " +
                              _vm._s(
                                _vm.menuList[
                                  _vm.sidebarParentCur.length > 13
                                    ? _vm.sidebarParentCur.slice(13)
                                    : _vm.sidebarParentCur
                                ].menu_name
                              ) +
                              "\n    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-scrollbar",
                    {
                      staticStyle: { height: "100%" },
                      attrs: { "wrap-class": "scrollbar-wrapper" },
                    },
                    [
                      _c(
                        "el-menu",
                        {
                          attrs: {
                            "default-active": _vm.activeMenu,
                            collapse: _vm.isCollapse,
                            "background-color": _vm.variables.menuBg,
                            "text-color": _vm.variables.menuText,
                            "unique-opened": true,
                            "active-text-color": _vm.variables.menuActiveText,
                            "collapse-transition": false,
                            router: true,
                            mode: "vertical",
                          },
                          on: { select: _vm.selectMenu },
                        },
                        [
                          _vm.menuList[
                            _vm.sidebarParentCur.length > 13
                              ? _vm.sidebarParentCur.slice(13)
                              : _vm.sidebarParentCur
                          ]
                            ? _vm._l(
                                _vm.menuList[
                                  _vm.sidebarParentCur.length > 13
                                    ? _vm.sidebarParentCur.slice(13)
                                    : _vm.sidebarParentCur
                                ].children,
                                function (route) {
                                  return _c("sidebar-item", {
                                    key: "sidebar" + route.id,
                                    attrs: {
                                      item: route,
                                      "base-path": _vm.includeRouteOrNot(
                                        route.menu_path
                                      ),
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.routerClick(route)
                                      },
                                    },
                                  })
                                }
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-open", on: { click: _vm.clickOutside } },
            [
              _c("i", {
                staticClass: "el-icon-arrow-left",
                class: _vm.isCollapse ? "active" : "",
              }),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }